
import React from 'react';
import { ArrowRight } from 'lucide-react';
import SolutionDiagram from './SolutionDiagram';

const HowItWorksSection = () => {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 reveal">
          <h2 className="text-3xl md:text-4xl font-semibold mb-2">How Does It Work?</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Traditionally we built data warehouses with BI reporting on top. Now LLMs change that paradigm.
          </p>
        </div>
        
        <SolutionDiagram />
        
        <div className="bg-primary/5 rounded-xl p-8 border border-primary/20 max-w-3xl mx-auto mt-12 reveal">
          <p className="text-lg font-medium mb-4">
            Isn't that simply wonderful? No more endless scrolling and not knowing if you are looking at the right thing.
          </p>
          <p className="text-lg">
            All you need to know is how to ask and we are ready to give you needed guidance. Excited already? We for sure are. What are you still waiting for? Get in touch and let's move!
          </p>
          
          <div className="mt-6">
            <a 
              href="/tell-me-more"
              className="inline-flex items-center text-primary font-medium group"
            >
              Contact us to get started
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
